import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { State } from 'src/app/reducers';
import { User } from 'src/app/store/auth/auth.models';

export interface UserViewerProps {
  label: string;
  value: string | any;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  private destroyer$: Subject<any> = new Subject();
  loading = true;
  loggedUser: User = null;
  model: any = {};
  userForm: FormGroup;
  errorMessage: string = null;
  UserDisplayFields: UserViewerProps[] = [];

  constructor(private fb: FormBuilder, private store: Store<State>) {
    this.store
      .select((state) => state.auth.authenticatedUser)
      .pipe(takeUntil(this.destroyer$))
      .subscribe((user) => {
        this.loggedUser = user;
      });
  }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      sub: [this.loggedUser && this.loggedUser.username],
      email: [this.loggedUser && this.loggedUser.email, []],
      Username: [this.loggedUser && this.loggedUser.username],
      family_name: [this.loggedUser && this.loggedUser.family_name],
      given_name: [this.loggedUser && this.loggedUser.given_name, []],
      email_verified: [this.loggedUser && this.loggedUser.email_verified, []],
    });
  }
}
